import Icon from "components/shared/Icon";
import Link from "components/shared/Link";
import { Fragment } from "react";
const mainClass = "help-question-item";

const QuestionItem = ({ module, modifier }) => {
	const { question, answer, webLinks, id } = module;
	const modifierClass = modifier ? `${mainClass}--${modifier}` : "";
	const relatedQuestionsModifier = "related-questions";

	const indicator = () => {
		return (
			<p
				aria-label={question.IndicatorAccessibleText || null}
				className={`${mainClass}__indicator ${mainClass}__indicator--question ${modifierClass}`}
			>
				{question.indicator}
			</p>
		);
	};

	return webLinks && webLinks.length && webLinks.length > 0 ? (
		<Fragment>
			{modifier === relatedQuestionsModifier && indicator()}
			<Link
				{...webLinks[0]}
				className={`${mainClass}__link ${modifierClass}`}
				key={`question-${id}`}
			>
				<div className={`${mainClass}__container ${modifierClass}`}>
					<div className={`${mainClass}__info ${modifierClass}`}>
						<div
							className={`${mainClass}__info--content ${mainClass}__info--question  ${modifierClass}`}
						>
							{modifier !== relatedQuestionsModifier && indicator()}
							<p
								className={`${mainClass}__text ${mainClass}__text--question ${modifierClass}`}
								dangerouslySetInnerHTML={{ __html: question.text }}
							></p>
						</div>
						{modifier !== relatedQuestionsModifier && (
							<div
								className={`${mainClass}__info--content ${mainClass}__info--answer  ${modifierClass}`}
							>
								<p
									aria-label={answer.IndicatorAccessibleText || null}
									className={`${mainClass}__indicator ${mainClass}__indicator--answer ${modifierClass}`}
								>
									{answer.indicator}
								</p>
								<div
									className={`${mainClass}__text ${mainClass}__text--answer ${modifierClass}`}
									dangerouslySetInnerHTML={{ __html: answer.text }}
								></div>
							</div>
						)}
					</div>
					{modifier !== relatedQuestionsModifier && (
						<div className={`${mainClass}__caret ${modifierClass}`}>
							<Icon
								icon="next"
								className={`${mainClass}__icon--next ${modifierClass}`}
							/>
						</div>
					)}
				</div>
			</Link>
		</Fragment>
	) : null;
};

export default QuestionItem;
